import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const CommsTopicModelSchema = z
  .object({
    id: z.string(),
    label: z.string()
  })
  .strict()

const CommsTopicModelFields = makeFieldKeys(CommsTopicModelSchema)

export type CommsTopicModel = z.infer<typeof CommsTopicModelSchema>

function validateCommsTopicModel(data: unknown): CommsTopicModel {
  try {
    return validateWithZodSchema(CommsTopicModelSchema, data, 'comms topic model')
  } catch (error) {
    throw new Error(`Comms topic model validation failed: ${error}`)
  }
}
